import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Api from '../../services/Api';
import { ApiResponse } from 'apisauce';
import {
  service,
  factories,
  models,
  IEmbedConfiguration,
} from 'powerbi-client';
import { Button } from 'react-bootstrap';
import './PowerBiReport.css';
import { SaveEditReport, SaveNewReport } from './redux-objects/actions';
import { UserInfo } from '../Login/common/defaults';
import { IPbiReport } from './business-objects/types';
import { toast } from 'react-toastify';
import * as urls from '../shared/urls';

export interface IPowerBiEditReportProps {
  //containerId: string;
  reportId?: string;
  history: any;
  currentUser: UserInfo;
  activeReport: IPbiReport;
  SaveEditReport?: (url: string, report: IPbiReport) => Promise<void>;
  SaveNewReport?: (url: string, report: IPbiReport) => Promise<void>;
}

const powerbi = new service.Service(
  factories.hpmFactory,
  factories.wpmpFactory,
  factories.routerFactory
);

class PowerBiEditReport extends React.Component<IPowerBiEditReportProps> {
  reportRef: React.Ref<HTMLDivElement>;
  reportContainer: HTMLElement;
  loading: JSX.Element;
  constructor(props: IPowerBiEditReportProps) {
    super(props);

    this.state = { accessToken: '', embedUrl: '', error: [] };

    this.reportRef = React.createRef();

    // Report container
    this.loading = (
      <div
        id={'reportContainer'} // + this.props.containerId}
        ref={this.reportRef}
        className='reportContainer'
      >
        Loading the report...
      </div>
    );
  }

  handleSave = (reportData: any) => {
    this.props
      .SaveEditReport(urls.POWERBI_EDIT_REPORT, this.props.activeReport)
      .then((result: any) => {
        console.log('result', result);
        toast.success('Saved');
      });
  };

  handleSaveAs = (reportData: any) => {
    const newReport: IPbiReport = {
      active: true,
      reportId: reportData.reportObjectId,
      name: reportData.reportName,
      reportTypeId: 1,
    };

    this.props
      .SaveNewReport(urls.POWERBI_SAVE_NEW_REPORT, newReport)
      .then((result: any) => {
        console.log('result', result);
        toast.success('Saved New Report');
        console.log('props', this.props);
        this.props.history.push('/PowerBiReports');
      });
  };

  doeEmbed = () => {
    const handleSave = (a: any) => this.handleSave(a);
    const handleSaveAs = (a: any) => this.handleSaveAs(a);

    if (this.reportRef !== null) {
      this.reportContainer = this.reportRef['current'];
    }

    Api.get(
      `PBI/GetEmbedParam?reportId=${this.props.activeReport.reportId}`
    ).then((result: ApiResponse<any>) => {
      //const embedData = $.parseJSON(result.data);
      const embedData = result.data;
      const reportLoadConfig = {
        type: 'report',
        tokenType: models.TokenType.Embed,
        accessToken: embedData.accessToken,
        embedUrl: embedData.embedUrl,
        permissions: models.Permissions.All /*gives maximum permissions*/,
        viewMode: models.ViewMode.Edit,
        /*
                // Enable this setting to remove gray shoulders from embedded report
                settings: {
                    background: models.BackgroundType.Transparent
                }
                */
      };

      // Use the token expiry to regenerate Embed token for seamless end user experience
      // Refer https://aka.ms/RefreshEmbedToken
      const tokenExpiry = embedData.embedTokenExpiry;

      // Embed Power BI report when Access token and Embed URL are available
      var report = powerbi.embed(this.reportContainer, reportLoadConfig);

      // Clear any other loaded handler events
      report.off('loaded');

      // Triggers when a report schema is successfully loaded
      report.on('loaded', function () {
        console.log('Report load successful');
      });

      // Clear any other rendered handler events
      report.off('rendered');

      // Triggers when a report is successfully embedded in UI
      report.on('rendered', function () {
        console.log('Report render successful');
      });

      // Clear any other error handler events
      report.off('error');

      // Handle embed errors
      report.on('error', function (event) {
        var errorMsg = event.detail;

        // Use errorMsg variable to log error in any destination of choice
        console.error(errorMsg);
        return;
      });

      report.off('saved');
      report.on('saved', function (event: any) {
        console.log(event.detail);
        if (event.detail.saveAs) {
          handleSaveAs(event.detail);
        } else {
          handleSave(event.detail);
        }
      });
    });
  };
  componentDidMount() {
    if (this.reportRef !== null) {
      this.reportContainer = this.reportRef['current'];
    }
  }
  // React function
  componentWillUnmount(): void {
    powerbi.reset(this.reportContainer);
  }
  public render() {
    this.doeEmbed();
    return this.loading;
  }
}

export function mapStateToProps(state: any) {
  return {
    webServiceURL: state.Application.backendURL,
    currentUser: state.Application.currentUser,
    activeReport: state.PowerBI.activeReport,
  };
}

const mapDispatchToProps = {
  SaveEditReport,
  SaveNewReport,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(PowerBiEditReport)
);
